import { vesselsData } from "./vesselData.js"
import { ENDPOINT , SIGNATURE_TYPE} from "../../constants/endpoint.js"
import axios from 'axios'
import moment from "moment";

var configWithToken = {
    headers: {
      "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
    },
  };

const state = {
    reparations: null,
    reparationVessels: null,
    selectedReparation: null,
    loading: false,
    reparationAccessories: null,
    amount: null
}

const mutations = {
    SET_REPARATION: (state, payload) => {
        const result = payload.filter(x => x.status != "")
        // console.log(result);
        state.reparations = result;
    },
    SET_VESSEL_REPARATIONS: (state, payload) => {
        state.reparationVessels = payload
        console.log(state.reparationVessels);
    },
    SET_VESSEL_REPARATION: (state, payload) => {
        state.selectedReparation = payload
        console.log(state.selectedReparation);
    },
    LOADING: (state, payload) => {
        state.loading = payload.loading
    },
    SET_REPARATION_STATUS: (state, payload) => {
        const data = vesselsData
        for (var i in data) {
            if (data[i].id == payload.id) {
                data[i].reparationStatus = payload.value;
                break;
            }
        }
        state.reparations = data
    },
    SET_REPARATION_FOR_ACCESSORIES_RECEIVED: (state, reparationAccessories) => {
        state.reparationAccessories = reparationAccessories;
    },
    SET_NUMBER_OF_REPARATION: (state, amount) => {
        state.amount = amount
    },

}

const actions = {
    setVesselReparations: async ({ commit }, payload) => {
        console.log(payload);
        const url = ENDPOINT.GET_VESSEL_REPARATIONS;
        const params = {
            status: payload.status,
        };
        await axios.get(url, { params }).then(res => {
            console.log("this is test :", res.data);
            commit("SET_VESSEL_REPARATIONS", res.data)
        }).catch(err => {
            console.log(err);
        })
    },
    setVesselRegistrationById: async ({ commit }, payload) => {
        const url = ENDPOINT.GET_VESSEL_REPARATIONS + "/" + payload;
        await axios.get(url).then(res => {
            console.log("this is test :", res.data);
            commit("SET_VESSEL_REPARATION", res.data)
        }).catch(err => {
            console.log(err);
        })
    },
    async setVesselReparationById ({ commit }, payload) {
        console.log("this is payload ==> ", payload);
        const url = ENDPOINT.GET_VESSEL_REPARATIONS_BY_ID + "/" + payload;

        await axios.get(url,null,configWithToken).then(res => {
            console.log("this is test :", res.data);
            commit("SET_VESSEL_REPARATION", res.data)
        }).catch(err => {
            console.log(err);
        })
    },
    setReparations: async ({ commit }, payload) => {
        const url = ENDPOINT.GET_VESSEL_REPARATIONS + "/status/reparation";
        const config = {
            headers: {
                "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
            },
        };
        await axios.get(url,null,config).then(res => {
            console.log("this is reparations :", res.data);
            commit('SET_REPARATION', res.data)
        }).catch(err => {
            console.log(err);
        })
        // const data = vesselsData
    },
    setReparationStatus: ({ commit }, payload) => {
        commit("SET_REPARATION_STATUS", payload)
    },
    createReparationManual: async ({ commit }, payload) => {
        const formData = new FormData();
        for (const document of payload.documents) {
            formData.append("files", document);
        }
        formData.append("registrationId", payload.registrationId);
        formData.append("detail", payload.detail);
        formData.append("accessories", JSON.stringify(payload.accessories));


        const url = ENDPOINT.GET_VESSEL_REPARATIONS + "/create/manual";
        const config = {
            headers: {
                "content-type": "multipart/form-data",
                "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
            },
        };
        commit("LOADING", { loading: true });

        await axios.post(url, formData, config).then(res => {
            console.log("reponse repatation created:", res.data);
            // commit("SET_VESSEL_REPARATION", res.data)
        }).catch(err => {
            console.log(err);
        })
    },
    async changeStatusReparation ({ commit }, payload) {
        console.log(payload);
        const url = ENDPOINT.GET_VESSEL_REPARATIONS;
        const config = {
            headers: {
                "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
            },
        };
        commit("LOADING", { loading: true });

        const data = {
            status: payload.status,
            id: payload.id
        }
        console.log(data);
        await axios.put(url, data, config).then( async(res) => {
            console.log("response reparation update:", res.data);
            const vessel = res.data.vessel

            if (payload.status == 'ยืนยันการติดตั้งอุปกรณ์') {
                const notificationReq = {
                  userId: res.data.createdBy.id,
                  title: "แจ้งซ่อม (ยืนยันการติดตั้งอุปกรณ์)",
                  body: `MMSI : ${vessel.mmsi}, เรือ : ${vessel.name}, ${vessel.zone.name} (${vessel.zone.branch})`
                }
                this.dispatch("notifications/sendNotificationToApplication", notificationReq)
            }
            let sigantureForm = { 
                fileName: payload.fileName,
                installationsId: res.data.installations[0].id, // reparation ID
                type: SIGNATURE_TYPE.INSTALLATION
              }
              
              const config = {
                headers: {
                  // "content-type": "multipart/form-data",
                  "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
                },
              };
      
              const createSignatureUrl = ENDPOINT.CREATE_SIGNATURE_BY_FILENAME
              await axios.post(createSignatureUrl , sigantureForm , config)
              .then((res) => {
                console.log(res);
              })
              .catch((error) =>{ 
                console.log(error);
              })
            // commit("SET_VESSEL_REPARATION", res.data)
        }).catch(err => {
            console.log(err);
        })
    },
    async getReparations({ commit }, status) {
        const url = `${ENDPOINT.GET_REPARATION_FOR_ACCESSORIES_RECEIVED}`;
        const config = {
            headers: {
              // "content-type": "multipart/form-data",
              "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
            },
          };
        await axios
            .get(url, { params: { status } },config)
            .then(async (response) => {
                const data = response.data;
                console.log("data ", data);
                await commit("SET_REPARATION_FOR_ACCESSORIES_RECEIVED", data);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => { });
    },
    async createAccessoriesReparation({ commit }, payload) {
        const url = ENDPOINT.CREATE_ACCESSORIES_REPARATION
        const config = {
            headers: {
                "Authorization": `Bearer ${localStorage.getItem('accessToken')}`,
            },
        };
        await axios.post(url, payload, config)
            .then(response => {
                console.log(response.data);
                const vessel = response.data.vessel
                const receiveDate = response.data.accessoriesReceive.receiveDate

                const notificationReq = {
                    userId: response.data.createdBy.id,
                    title: `แจ้งซ่อม (แจ้งรับอุปกรณ์วันที่ ${moment(receiveDate).add(543, "year").format("DD/MM/YYYY")})`,
                    body: `MMSI : ${vessel.mmsi}, เรือ : ${vessel.name}, ${vessel.zone.name} (${vessel.zone.branch})`
                }
                this.dispatch("notifications/sendNotificationToApplication", notificationReq)
                this.dispatch("notifications/getNotificationForNavbar")
            })
            .catch(error => {
                console.log(error);
            })
    },
    async getNumberOfReparation({ commit }, userId) {
        const url = `${ENDPOINT.GET_NUMBER_OF_REPARATION}`;
        await axios
            .get(url,null,configWithToken)
            .then(async (response) => {
                const data = response.data;
                // console.log("data ", data);
                await commit("SET_NUMBER_OF_REPARATION", data);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
            });
    }

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}